import { useContext } from 'react';
import { PNGlobalContext } from '@mummssoftware/global-context/PNGlobalContext';
import { Context } from '../context';

/**
 * Note list for the current PN view.
 *
 * Unfiltered (incl. small tile): progressNotesGlobal is the source of truth so
 * cache upserts (e.g. order addendum) re-render without a full refetch or
 * class setState sync.
 * Entity-filtered: local context.progressNotes (subset for that entity).
 *
 * Returns progressNotebyEntity[]: getProgressNotes / upsertProgressNoteGlobal
 * store entity dto keyed by type; PNGlobalContext types the cache as progressNote[]
 * loosely, so we cast at the boundary.
 */
export const useProgressNotes = (): mumms.progressNotebyEntity[] => {
  const { progressNotesGlobal } = useContext(PNGlobalContext);
  const { progressNotes: localNotes, entityType } = useContext(Context);

  if (!entityType && progressNotesGlobal != null) {
    return progressNotesGlobal as mumms.progressNotebyEntity[];
  }
  return localNotes ?? [];
};
